import { call, fork, takeLatest, take, put } from 'redux-saga/effects';

import session from '../session'
import { getNavigate } from '../../navigationService';

import { fetchLogin, fetchUser, fetchLogout, fetchCurrentUser, setAcceptTerms, checkPasswordAcceptedByPolitics, fetchAssociatedAccounts, fetchFullPdf as API_fetchFullPdf } from '../api';
import { userActions } from './actions';


export function* loadUser({ payload }) {
  const { userId, data } = payload;
  yield call(fetchLogin, userId, data);
  getNavigate()('/home');
}

export function* currentUser() {
  yield call(fetchCurrentUser);
}

export function* getProfile({ payload }) {
  if (session.getAuthenticated()) {
    yield call(fetchUser);
  }
}

export function* logout({ payload }) {
  yield call(fetchLogout);
  yield call(session.deleteSession);
  getNavigate()('/welcome');
}

export function* acceptTerms() {
    yield call(setAcceptTerms);
}

export function* checkPassword({ payload }) {
    const { password } = payload;
    yield call(checkPasswordAcceptedByPolitics, password);
}

export function* getAssociatedAccounts({ payload }) {
    const { email } = payload;
    yield call(fetchAssociatedAccounts, email);
}

export function* downloadFullPdf({ payload }) {
  const { userId } = payload;
  yield call(API_fetchFullPdf, userId);
}


//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadUser() {
  yield takeLatest(userActions.LOAD_USER, loadUser);
}

export function* watchGetProfiler() {
  yield takeLatest(userActions.GET_PROFILE, getProfile);
}

export function* watchCurrentUser() {
  yield takeLatest(userActions.CURRENT_USER, currentUser);
}

export function* watchFetchUserSucces() {
  while (true) {
    const { payload } = yield take(userActions.FETCH_USER_SUCCESS);
    if(payload.data.email) {
        session.setAuthenticated(1);
    }
  }
}

export function* watchFetchUserFailed() {
  while (true) {

    const { payload } = yield take(userActions.FETCH_USER_FAILED);

    if (!payload.success && payload.message === "Unauthorized") {
      session.deleteSession();
    }
  }
}


export function* watchFetchUserLogout() {
  yield takeLatest(userActions.LOGOUT, logout);
}

export function* watchAcceptTerms() {
    yield takeLatest(userActions.ACCEPT_TERMS, acceptTerms);
}

export function* watchCheckPasswordAcceptedByPolitics() {
    yield takeLatest(userActions.CHECK_PASSWORD_ACCEPTED_BY_POLITICS, checkPassword);
}

export function* watchFetchAssociatedAccounts() {
    yield takeLatest(userActions.FETCH_ASSOCIATED_ACCOUNTS, getAssociatedAccounts);
}

export function* watchFetchFullPdf() {
  yield takeLatest(userActions.FETCH_FULL_PDF, downloadFullPdf);
}

//=====================================
//  ROOT
//-------------------------------------

export const userSagas = [
  fork(watchLoadUser),
  fork(watchFetchUserSucces),
  fork(watchFetchUserFailed),
  fork(watchGetProfiler),
  fork(watchFetchUserLogout),
  fork(watchCurrentUser),
  fork(watchAcceptTerms),
  fork(watchCheckPasswordAcceptedByPolitics),
  fork(watchFetchAssociatedAccounts),
  fork(watchFetchFullPdf)
];
